import styled from 'styled-components';
import { ImageUtils } from '../../utils/ImageUtils';
import { mobileQuery } from '../../utils';

export const Flare = () => {
  return (
    <FlareContainer>
      <Inner></Inner>
    </FlareContainer>
  );
};

const FlareContainer = styled.div`
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 450px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;

const Inner = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: 2000px 450px;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${ImageUtils.WebFlareImage});
  background-repeat: repeat-x;

  ${mobileQuery} {
    background-size: contain;
    background-position: top;
    background-image: url(${ImageUtils.MobileFlareImage});
  }
`;
